import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@mipro/ngx-charts';
import { InfluxService } from './influx.service';
import { InfluxGraphComponent } from './influx-graph/influx-graph.component';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule,
    NgxChartsModule,
    NgbTypeaheadModule,
  ],
  declarations: [InfluxGraphComponent],
  exports: [InfluxGraphComponent],
  providers: [InfluxService]
})
export class InfluxModule {
}
